<template>
  <b-container fluid>
    <b-row>
      <b-col :lg="cols">
        <card>
          <TableActionHeader
            v-on:filterChange="onFilterChange"
            v-on:newItem="onNewItem"
            :newButton="$UIPrivilegeCreate('devices', 'devicegroups')"
          />
          <DeviceGroupTable :filter="filter" v-on:selectItem="onSelectItem" />
        </card>
      </b-col>
      <b-col>
        <info-card v-if="formType == ''" />
        <card v-if="formType == 'new'">
          <CardHeader :title="$t('item.new')" />
          <DeviceGroupForm :item="item" :action="formType" :newItemEvent="newItemEvent"/>
        </card>
        <card v-if="formType === 'edit'">
          <CardHeader :title="$t('item.edit') + ': ' + this.itemName" />
          <DeviceGroupForm
            :item="item"
            @itemName="handleItemName"
            :action="formType"
          />
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import TableActionHeader from '@/components/Misc/TableActionHeader'
import DeviceGroupTable from '@/components/Devices/DeviceGroup/DeviceGroupTable.vue'
import DeviceGroupForm from '@/components/Devices/DeviceGroup/DeviceGroupForm.vue'
import InfoCard from '@/components/Misc/InfoCard.vue'

export default {
  name: 'DeviceGroups',
  components: {
    TableActionHeader,
    DeviceGroupTable,
    DeviceGroupForm,
    InfoCard,
  },
  data: function () {
    return {
      showForm: true,
      cols: 8,
      filter: null,
      formType: '',
      item: null,
      itemName: '', // original item.name
      newItemEvent: 0
    }
  },
  methods: {
    onFilterChange(filter) {
      this.filter = filter
      this.toggleFormVisibility(true, '')
    },
    toggleFormVisibility(isVisible, formType) {
      this.showForm = isVisible
      this.formType = formType
      this.cols = this.showForm ? 8 : 12
    },
    onNewItem() {
      this.item = null
      this.toggleFormVisibility(true, 'new')
      this.newItemEvent = Date.now();
    },
    onSelectItem(item) {
      if (item) {
        this.item = JSON.parse(JSON.stringify(item))
        this.toggleFormVisibility(true, 'edit')
        this.itemName = this.item.name
      }
    },
    handleItemName(itemName) {
      this.itemName = itemName
    },
  },
}
</script>
